import Onboardingv2 from "./Onboardingv2";

export default Onboardingv2;
